<template>
	<u-animate-container>
		<div class="portfolio">
			<div class="container-fluid pb-5 container-top">
				<div class="container p-0">
					<b-row>
						<b-col cols="12" class="text-center pt-5 mt-5 p-0">
				    		<h1 class="section-title">{{configs['portfolio_title']}}</h1>
							<b-col md="8" offset-md="2">
								<p v-html="configs['portfolio_welcome_txt']"></p>
							</b-col>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="container content position-relative space-to-footer">
				<u-animate
			      name="fadeInUp"
				  :offset="0"
				  delay="0s" 
			      duration="1.2"
				  :begin="true" 
			      :iteration="1"
			    >
				    <b-row>
						<b-col cols="12">
				    		<PortfolioFilter v-bind:categories="categories" v-bind:projects="projects"/></PortfolioFilter>
						</b-col>
					</b-row>
				</u-animate>
			</div>
			<Footer></Footer>
		</div>
	</u-animate-container>
</template>
<script>
import PortfolioFilter from '@/components/PortfolioFilter.vue'

export default {
  name: 'portfolio',
  components: {
	PortfolioFilter	
  },
  data() {
  	return {
  		projects: this.configs['projects'],
		categories: this.configs['projects_categories'],
  	}
  }
}
</script>
<style scoped>
.container-top {
	background-image: url('../assets/images/003Background_Portfolio.jpg');
}
</style>